module.exports = __webpack_public_path__ + "1bac41ca339e05f64509c53c7f6a0e01.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/fonts/bulorounded-bolditalic.woff
 ** module id = 18
 ** module chunks = 0
 **/